import { Button } from '@design-systems/canvas-ui'

interface IInteractiveButton {
    children: React.ReactNode
    style: string
    onClick?: (value: string) => void
}

export const InteractiveButton = ({
    children,
    style,
    onClick,
}: IInteractiveButton) => (
    <Button
        className={`hc8-ph-none hc8-pv-none hc8-ta-left ${style}`}
        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
            if (onClick) {
                onClick(e.currentTarget.textContent || '')
            }
        }}
        variant="ghost"
        size="sm"
    >
        {children}
    </Button>
)
